'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'clsx';
import PropTypes from 'prop-types';

import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import Link from 'components/ui/Link';
import EntryLink from 'components/ui/Link/EntryLink';
import RichText from 'components/ui/RichText';
import {
    getAccessibleEntryLinkLabel,
    getAccessibleLinkLabel,
} from 'components/ui/RichText/defaults';
import Text from 'components/ui/Text';

import { blockRootProps } from 'utils';

import styles from './BlockRichText.module.scss';

const BlockRichText = ({
    anchorId,
    __typename,
    richText,
    flushTop,
    flushBottom,
}) => {
    const richTextOverrides = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return (
                    <Text
                        as="p"
                        baseTheme="bodySmall"
                        themes={{ large: 'bodyMedium' }}
                        className={styles.bodyText}
                    >
                        {children}
                    </Text>
                );
            },
            [INLINES.ENTRY_HYPERLINK]: node => {
                return (
                    <EntryLink
                        entry={node?.data?.target}
                        className={styles.link}
                        aria-label={getAccessibleEntryLinkLabel(
                            node.content,
                            node?.data?.target
                        )}
                    >
                        {node.content[0].value}
                    </EntryLink>
                );
            },
            [INLINES.HYPERLINK]: node => {
                return (
                    <Link
                        className={styles.link}
                        href={node.data.uri}
                        aria-label={getAccessibleLinkLabel(
                            node.content,
                            node.data.uri
                        )}
                    >
                        {node.content[0].value}
                    </Link>
                );
            },
        },
    };

    return (
        <div
            {...blockRootProps(anchorId, __typename)}
            className={cx(styles.richTextBlock, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
            })}
        >
            <RichText richText={richText} overrides={richTextOverrides} />
        </div>
    );
};

BlockRichText.propTypes = {
    anchorId: PropTypes.string,
    __typename: PropTypes.string,
    richText: PropTypes.object.isRequired,
    flushTop: PropTypes.bool,
    flushBottom: PropTypes.bool,
};

export default BlockRichText;
